import React, { useEffect, useRef, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDimensionsDrillDown,
  makeSelectDivisions,
  makeSelectIsLoadingDimensions,
  makeSelectShowDimensionBenchmark,
} from "./selectors"
import { getDimensionsWatcher } from "./actions"

import "./index.less"

import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../../../utils/storage"
import ResultByDimensionChart from "../../../ReChart/ResultByDimensionChart"
import { Spin } from "antd"
import { Link } from "react-router-dom"
import questionIcon from "images/question.svg"
import {
  searchItemInTree,
  searchTree,
  truncateText,
  validate,
} from "../../../../../utils/functions"
import PopoverImpact from "../../../PopoverImpact"
import { QuestionCircleFilled } from "@ant-design/icons"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function WidgetResultByDimension(props) {
  const [measureID] = useState(props.idMeasure)
  const [divisionID] = useState(props.idDivisionSelected)
  const [dimensionParent, setDimensionParent] = useState(0)
  const [dataAux, setDataAux] = useState([])
  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }
  }, [props.idMeasure, props.idDivisionSelected])

  useEffect(() => {
    setDataChart()
  }, [props.dimensionsDrillDown])

  useEffect(() => {
    setDataChart()
  }, [dimensionParent])

  const initGetData = async () => {
    const {
      idMeasure,
      getDimensions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
      dimensionsData
    } = props
    const params = {
      dimensionsData,
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }
    getDimensions(params)
  }

  const setDataChart = () => {
    const { dimensionsDrillDown, measureGeneral } = props
    const dataResult = []
    let result = []
    if (dimensionParent === 0) {
      result = [...dimensionsDrillDown]
    } else {
      result = searchTree([...dimensionsDrillDown], dimensionParent)
    }
    result.map((row) => {
      if (row.engagement) {
        return
      }
      let newValue = row.value
      if (!row.anonymity_check.valid) {
        newValue = 100
      }
      if (row.childs) {
        row.childs.sort((a, b) => {
          if (a.id_question > b.id_question) {
            return 1
          }
          if (a.id_question < b.id_question) {
            return -1
          }
          return 0
        })
      }
      let newName =
        row.name === "Resultado total"
          ? measureGeneral.metric_total_label
          : row.name
      dataResult.push({
        name: `${newName}`,
        impact: row.impact,
        name_sort: truncateText(newName, 15),
        id_dimension: row.id_dimension,
        id_dimension_parent: row.id_dimension_parent,
        id: row.id,
        id_parent: row.id_parent,
        value: newValue,
        childs: row.childs,
        color: row.color,
        recipients: row.recipients,
        employees: row.employees,
        prev_value: row.prev_value,
        benchmark_value: row.benchmark_value,
        anonymity_check: row.anonymity_check,
        value_visible: row.value_visible,
      })
    })
    setDataAux(dataResult)
  }

  const renderTitle = () => {
    const {
      idMeasure,
      idDivisionSelected,
      selectedSegment,
      measureGeneral,
    } = props

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""
    if (idDivisionSelected) {
      queryDivision = `&id_division=${idDivisionSelected}`
    }
    if (selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }
    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}${queryDivision}${querySegment}`
    }
    const link = `/reports/measure/${idMeasure}/divisions/${idDivisionSelected ||
      "all"}/dimensions${queryParams}`
    return (
      <div className="WidgetResultByDimension-container-chart-header-container">
        <div className="WidgetResultByDimension-container-chart-header-container-title">
          {measureGeneral.segments.length > 1 && selectedSegment === 0
            ? "Resultado por dimensión"
            : measureGeneral.is_engagement
            ? "Resultado por dimensión"
            : "Resultado por dimensión"}
          <PopoverImpact
            container={
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  marginLeft: 4,
                  cursor: "pointer",
                }}
              />
            }
          />
        </div>
        <div className="WidgetResultByDimension-container-chart-header-container-link">
          <Link to={link}>{"Ir a análisis detallado >"}</Link>
        </div>
      </div>
    )
  }

  const getDataChildren = (data) => {
    if (
      validate.exist(data.childs) &&
      data.childs.length > 0 &&
      data.employees >= data.anonymity_check.current_used
    ) {
      setDimensionParent(data.id)
    }
  }

  const getBackData = (idDimensionParent) => {
    const result = searchItemInTree(
      [...props.dimensionsDrillDown],
      idDimensionParent
    )
    setDimensionParent(result.id_parent)
  }

  const renderChart = () => {
    const { measureGeneral, showDimensionBenchmark } = props
    return (
      <ResultByDimensionChart
        data={dataAux}
        measureGeneral={measureGeneral}
        getDataChildren={getDataChildren}
        getBackData={getBackData}
        dimensionParent={dimensionParent}
        showDimensionBenchmark={showDimensionBenchmark}
        hideImpact
      />
    )
  }

  const renderContainer = () => {
    if (props.isLoadingDimensions) {
      return (
        <div className="WidgetResultByDimension-container">
          <div className="WidgetResultByDimension-container-chart">
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="WidgetResultByDimension-container">
        <div className="WidgetResultByDimension-container-chart">
          <div className="WidgetResultByDimension-container-chart-header">
            {renderTitle()}
          </div>
          <div className="WidgetResultByDimension-container-chart-container">
            {renderChart()}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="WidgetResultByDimension"
      style={{
        width: props.measureGeneral.has_enps ? "100%" : "100%",
      }}>
      {renderContainer()}
    </div>
  )
}

WidgetResultByDimension.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingDimensions: PropTypes.bool,
  dimensionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getDimensions: PropTypes.func,
  showDimensionBenchmark: PropTypes.bool,
  selectedSegment: PropTypes.number,
  dimensionsData: PropTypes.object
}

const mapStateToProps = createStructuredSelector({
  isLoadingDimensions: makeSelectIsLoadingDimensions(),
  dimensionsDrillDown: makeSelectDimensionsDrillDown(),
  divisions: makeSelectDivisions(),
  showDimensionBenchmark: makeSelectShowDimensionBenchmark(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetResultByDimension", reducer })
const withSaga = injectSaga({ key: "widgetResultByDimension", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDimension)
